export const TEMPLE_WEBSTER = '22753'

interface PartnerCapabilities {
  hasDespatchIntegration: boolean
}

const PARTNER_CONFIG: Record<string, PartnerCapabilities> = {
  [TEMPLE_WEBSTER]: {
    hasDespatchIntegration: true,
  },
}

const DEFAULT_CAPABILITIES: PartnerCapabilities = {
  hasDespatchIntegration: false,
}

export const getPartnerCapabilities = (
  partnerCode?: string | null,
): PartnerCapabilities => {
  if (!partnerCode) return DEFAULT_CAPABILITIES
  return PARTNER_CONFIG[partnerCode] ?? DEFAULT_CAPABILITIES
}
